import React, { useContext, useRef } from 'react';
import { StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';

const H2 = ({ style, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h2);

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'H2',
                fontFamily: layout.styleGuide.h2.fontFamily,
                condensedFontFamily: layout.styleGuide.h2.condensedFontFamily,
                fontSize: layout.styleGuide.h2.fontSize,
                color: layout.styleGuide.h2.color
            }}
            numberOfLines={1}
            ref={ref}
            style={StyleSheet.flatten([Style.h2, layout.styleGuide.h2, style, overflowStyle])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h2: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: '24pt'
    }
});

H2.propTypes = {
    text: PropTypes.string.isRequired
};

export default H2;
